(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/draw-handler/client/create-draw-handler.js') >= 0) return;  svs.modules.push('/components/sport/draw-handler/client/create-draw-handler.js');
'use strict';

var _svs$draw$data$draws$, _svs;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$components$sport = svs.components.sport.drawHandler.common,
  createDrawModel = _svs$components$sport.createDrawModel,
  createDrawHandlerBase = _svs$components$sport.createDrawHandlerBase,
  pipe = _svs$components$sport.functional.pipe;
const createJupiterSocketInstance = svs.components.sport.drawHandler.client.createJupiterSocketInstance;
const ApiProxy = svs.components.lbUtils.apiProxy.ApiProxy;
const drawsData = (_svs$draw$data$draws$ = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.draw) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.draws) === null || _svs === void 0 ? void 0 : _svs.draws) !== null && _svs$draw$data$draws$ !== void 0 ? _svs$draw$data$draws$ : {};
const apiProxy = ApiProxy.create();
const jupiter = apiProxy.fetch.bind(apiProxy);
const socket = createJupiterSocketInstance();
const createDrawHandler = function () {
  let privateInterface = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    let publicInterface = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    for (const _ref of Object.entries(drawsData)) {
      var _ref2 = _slicedToArray(_ref, 2);
      const drawData = _ref2[1];
      const draw = createDrawModel(drawData);
      privateInterface.drawCache.setModel(draw);
    }
    return publicInterface;
  };
};

const privateInterface = {
  jupiter,
  socket
};
const fns = [createDrawHandlerBase, createDrawHandler].map(fn => fn(privateInterface));
const drawHandlerCreator = pipe(...fns);
setGlobal('svs.components.sport.drawHandler.client.createDrawHandler', drawHandlerCreator);

 })(window);